import PropTypes from 'prop-types';
import FormGroup from 'components/FormGroup';
import GlobalContext from 'contexts';
import { useContext } from 'react';
import Api from 'utils/api';
import useFetchData from '../../../hooks/useFetchData';
import moment from 'moment';

export function HealthCoachSummey({ handleClose }) {
  const { currentMeeting } = useContext(GlobalContext);
  console.log('currentMeeting', currentMeeting);

  const { data: coatchMeetingSummery } = useFetchData(
    `client-survey-measures/getMedicalSummery/${currentMeeting.clientProductUuid}/63`
  );

  const thisSummary = coatchMeetingSummery?.summery;

  const fields = [
    {
      name: 'summery',
      label: 'סיכום',
      required: true,
      type: 'textarea',
      breakLine: true,
      default: thisSummary,
    },
    {
      name: 'isDoctor',
      label: 'המלצה לפגישה עם רופא',
      type: 'switch',
    },
  ];

  const onSubmit = (data) => {
    data.meetingId = currentMeeting.id;
    Api.post(
      `/client-survey-measures/coachSummery/${currentMeeting.clientProductUuid}`,
      data
    ).then(() => {
      handleClose(null);
      window.location.reload();
    });
  };

  return (
    <div>
      <div>
        סיכום מאמן בריאות
        {thisSummary && coatchMeetingSummery?.lastUpdated && (
          <span>
            {' '}
            נכתב ב־
            {moment(coatchMeetingSummery.lastUpdated).format(
              'DD.MM.YYYY HH:mm'
            )}
          </span>
        )}
      </div>
      {coatchMeetingSummery && (
        <FormGroup
          fields={fields}
          data={coatchMeetingSummery}
          onSubmit={onSubmit}
        ></FormGroup>
      )}
      {/* {coatchMeetingSummery?.summery && (
        <span>נכתב ע"י {coatchMeetingSummery.updatedBy}</span>
      )} */}
    </div>
  );
}

HealthCoachSummey.propTypes = {
  handleClose: PropTypes.func,
};
